import React from 'react'
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import Footer from './components/Footer/Footer';
import HomeMain from './components/Home/HomeMain';
import Depomain from './components/SubServices/depo/DepoMain.jsx';
import BabyfoodMain from './components/SubServices/babyfood/BabyFoodMain.jsx';
import ParaquatMain from './components/SubServices/paraquat/PraquatMain.jsx';
import RoundUpMain from './components/SubServices/roundup/RoundupMain.jsx';
import ServiceMain from './components/Service/ServiceMain.jsx';
import AboutUs from './components/AboutUs/AboutMain.jsx';
import ContactUs from './components/ContactUs/ContactMain.jsx';
import AFFFMain from './components/SubServices/AFFF/AFFFMain.jsx';
import BardPowerPortMain from './components/SubServices/BardPowerPort/BardPowerPortMain.jsx';
import TalcumMain from './components/SubServices/TalcumPowder/TalcumPowderMain.jsx';
import TransvaginalMain from './components/SubServices/TransvaginalMesh/TransvaginalMain.jsx';
import UltraProcessedMain from './components/SubServices/UltraProcessedFood/UltraProcessedMain.jsx';
import OxbrytaMain from './components/SubServices/Oxbryta/OxbrytaMain.jsx';
import PFASMain from './components/SubServices/PFAS/PFASMain.jsx';
import ReactGA from 'react-ga4'
import OzempicLawsuitMain from './components/SubServices/OzempicLawsuit/OzempicMain.jsx';
import HairRelaxerLawsuitMain from './components/SubServices/HairRelaxerLawsuit/HairRelaxerLawsuit.jsx';
import DepoProveraLawsuit from './components/Lawsuits/DepoProveraLawsuit.jsx';
import TalcumPowderLawsuit from './components/Lawsuits/TalcumPowderLawsuit.jsx';
import HerniaMeshLawsuit from './components/Lawsuits/HerniaMeshLawsuit.jsx';
import OzempicLawsuit from './components/Lawsuits/OzempicLawsuit.jsx';
import HairRelaxerLawsuit from './components/Lawsuits/HairRelaxerLawsuit.jsx';
import RideshareSexualAssaultLawsuit from './components/Lawsuits/RideshareSexualAssaultLawsuit.jsx';
import SocialMediaAddictionLawsuit from './components/Lawsuits/SocialMediaAddictionLawsuit.jsx';
import RobloxSALawsuit from './components/Lawsuits/RobloxSALawsuit.jsx';
import RoundupLawsuit from './components/Lawsuits/RoundupLawsuit.jsx';
import DepoProveraLawsuitB from './components/Lawsuits/DepoProveraLawsuitB.jsx';
import TalcumPowderLawsuitB from './components/Lawsuits/TalcumPowderLawsuitB.jsx';
import HerniaMeshLawsuitB from './components/Lawsuits/HerniaMeshLawsuitB.jsx';
import OzempicLawsuitB from './components/Lawsuits/OzempicLawsuitB.jsx';
import HairRelaxerLawsuitB from './components/Lawsuits/HairRelaxerLawsuitB.jsx';
import RideshareSexualAssaultLawsuitB from './components/Lawsuits/RideshareSexualAssaultLawsuitB.jsx';
import SocialMediaAddictionLawsuitB from './components/Lawsuits/SocialMediaAddictionLawsuitB.jsx';
import RobloxSALawsuitB from './components/Lawsuits/RobloxSALawsuitB.jsx';
import DepoProveraLawsuitC from './components/Lawsuits/DepoProveraLawsuitC.jsx';
import TalcumPowderLawsuitC from './components/Lawsuits/TalcumPowderLawsuitC.jsx';
import HerniaMeshLawsuitC from './components/Lawsuits/HerniaMeshLawsuitC.jsx';
import OzempicLawsuitC from './components/Lawsuits/OzempicLawsuitC.jsx';
import HairRelaxerLawsuitC from './components/Lawsuits/HairRelaxerLawsuitC.jsx';
import RideshareSexualAssaultLawsuitC from './components/Lawsuits/RideshareSexualAssaultLawsuitC.jsx';
import SocialMediaAddictionLawsuitC from './components/Lawsuits/SocialMediaAddictionLawsuitC.jsx';
import RobloxSALawsuitC from './components/Lawsuits/RobloxSALawsuitC.jsx';
import DepoProveraLawsuitD from './components/Lawsuits/DepoProveraLawsuitD.jsx';
import TalcumPowderLawsuitD from './components/Lawsuits/TalcumPowderLawsuitD.jsx';
import HerniaMeshLawsuitD from './components/Lawsuits/HerniaMeshLawsuitD.jsx';
import OzempicLawsuitD from './components/Lawsuits/OzempicLawsuitD.jsx';
import HairRelaxerLawsuitD from './components/Lawsuits/HairRelaxerLawsuitD.jsx';
import RobloxSALawsuitD from './components/Lawsuits/RobloxSALawsuitD.jsx';
import DupixentLawsuitD from './components/Lawsuits/DupixentLawsuitD.jsx';
import DupixentLawsuitA from './components/Lawsuits/DupixentLawsuitA.jsx';
import DupixentLawsuitB from './components/Lawsuits/DupixentLawsuitB.jsx';
import DupixentLawsuitC from './components/Lawsuits/DupixentLawsuitC.jsx';
import DupixentLawsuit from './components/SubServices/DupixentLawsuit/OzempicMain.jsx';
import SocialMediaAddictionLawsuits from './components/SubServices/SocialMediaAddictionLawsuit/OzempicMain.jsx';
import HerniaMeshLawsuits from './components/SubServices/HerniaMeshLawsuit/OzempicMain.jsx';
import Medicare from './components/SubServices/Medicare/OzempicMain.jsx';
import SSDILawsuit from './components/Lawsuits/SSDILawsuit.jsx';
import SSDILawsuitServices from './components/Lawsuits/SSDILawsuitServices.jsx';
import NotFound from './components/NotFound.jsx';
import NewMedicalOzempicLawsuitB from './components/RetellFileUpload/NewMedicalOzempicLawsuitB.jsx';

import DynamicTemplatePage from './pages/DynamicTemplatePage.jsx';
import ACAHealthInsuranceLawsuit from './components/Lawsuits/ACAHealthInsuranceLawsuit.jsx';
import AutoInsuranceLawsuit from './components/Lawsuits/AutoInsuranceLawsuit.jsx';
import FinalExpenseInsuranceLawsuit from './components/Lawsuits/FinalExpenseInsuranceLawsuit.jsx';
import LegalPage from './components/Legal/LegalPage.jsx';
import { LEGAL_PAGES } from './components/Legal/legalPages.js';

//kq lander imports
import KqDepoProveraLawsuit from './components/KqLawsuits/DepoProveraLawsuit.jsx';
import KqTalcumPowderLawsuit from './components/KqLawsuits/TalcumPowderLawsuit.jsx';
import KqHerniaMeshLawsuit from './components/KqLawsuits/HerniaMeshLawsuit.jsx';
import KqOzempicLawsuit from './components/KqLawsuits/OzempicLawsuit.jsx';
import KqHairRelaxerLawsuit from './components/KqLawsuits/HairRelaxerLawsuit.jsx';
import KqRideshareSexualAssaultLawsuit from './components/KqLawsuits/RideshareSexualAssaultLawsuit.jsx';
import KqSocialMediaAddictionLawsuit from './components/KqLawsuits/SocialMediaAddictionLawsuit.jsx';
import KqRobloxSALawsuit from './components/KqLawsuits/RobloxSALawsuit.jsx';
import KqRoundupLawsuit from './components/KqLawsuits/RoundupLawsuit.jsx';

import KqDepoProveraLawsuitB from './components/KqLawsuits/DepoProveraLawsuitB.jsx';
import KqTalcumPowderLawsuitB from './components/KqLawsuits/TalcumPowderLawsuitB.jsx';
import KqHerniaMeshLawsuitB from './components/KqLawsuits/HerniaMeshLawsuitB.jsx';
import KqOzempicLawsuitB from './components/KqLawsuits/OzempicLawsuitB.jsx';
import KqHairRelaxerLawsuitB from './components/KqLawsuits/HairRelaxerLawsuitB.jsx';
import KqRideshareSexualAssaultLawsuitB from './components/KqLawsuits/RideshareSexualAssaultLawsuitB.jsx';
import KqSocialMediaAddictionLawsuitB from './components/KqLawsuits/SocialMediaAddictionLawsuitB.jsx';
import KqRobloxSALawsuitB from './components/KqLawsuits/RobloxSALawsuitB.jsx';

import KqDepoProveraLawsuitC from './components/KqLawsuits/DepoProveraLawsuitC.jsx';
import KqTalcumPowderLawsuitC from './components/KqLawsuits/TalcumPowderLawsuitC.jsx';
import KqHerniaMeshLawsuitC from './components/KqLawsuits/HerniaMeshLawsuitC.jsx';
import KqOzempicLawsuitC from './components/KqLawsuits/OzempicLawsuitC.jsx';
import KqHairRelaxerLawsuitC from './components/KqLawsuits/HairRelaxerLawsuitC.jsx';
import KqRideshareSexualAssaultLawsuitC from './components/KqLawsuits/RideshareSexualAssaultLawsuitC.jsx';
import KqSocialMediaAddictionLawsuitC from './components/KqLawsuits/SocialMediaAddictionLawsuitC.jsx';
import KqRobloxSALawsuitC from './components/KqLawsuits/RobloxSALawsuitC.jsx';

import KqDepoProveraLawsuitD from './components/KqLawsuits/DepoProveraLawsuitD.jsx';
import KqTalcumPowderLawsuitD from './components/KqLawsuits/TalcumPowderLawsuitD.jsx';
import KqHerniaMeshLawsuitD from './components/KqLawsuits/HerniaMeshLawsuitD.jsx';
import KqOzempicLawsuitD from './components/KqLawsuits/OzempicLawsuitD.jsx';
import KqHairRelaxerLawsuitD from './components/KqLawsuits/HairRelaxerLawsuitD.jsx';
import KqRobloxSALawsuitD from './components/KqLawsuits/RobloxSALawsuitD.jsx';

import KqDupixentLawsuitD from './components/KqLawsuits/DupixentLawsuitD.jsx';
import KqDupixentLawsuitA from './components/KqLawsuits/DupixentLawsuitA.jsx';
import KqDupixentLawsuitB from './components/KqLawsuits/DupixentLawsuitB.jsx';
import KqDupixentLawsuitC from './components/KqLawsuits/DupixentLawsuitC.jsx';
import KqSSDILawsuit from './components/KqLawsuits/SSDILawsuit.jsx';
import QualificationForm from './components/SSDIEKQ.jsx';
import SSDIRIG from './components/SSDIRIG.jsx';
import QualificationForm2 from './components/SSDIE.jsx';
import Test from './components/Lawsuits/Test.jsx';

import RobloxSALawsuit1 from './components/Lawsuits/RobloxSALawsuit1.jsx';
import RobloxSALawsuit2 from './components/Lawsuits/RobloxSALawsuit2.jsx';
import RobloxSALawsuit3 from './components/Lawsuits/RobloxSALawsuit3.jsx';

import RobloxSALawsuitB1 from './components/Lawsuits/RobloxSALawsuitB1.jsx';
import RobloxSALawsuitB2 from './components/Lawsuits/RobloxSALawsuitB2.jsx';
import RobloxSALawsuitB3 from './components/Lawsuits/RobloxSALawsuitB3.jsx';

import RobloxSALawsuitC1 from './components/Lawsuits/RobloxSALawsuitC1.jsx';
import RobloxSALawsuitC2 from './components/Lawsuits/RobloxSALawsuitC2.jsx';
import RobloxSALawsuitC3 from './components/Lawsuits/RobloxSALawsuitC3.jsx';

import RobloxSALawsuitD1 from './components/Lawsuits/RobloxSALawsuitD1.jsx';
import RobloxSALawsuitD2 from './components/Lawsuits/RobloxSALawsuitD2.jsx';
import RobloxSALawsuitD3 from './components/Lawsuits/RobloxSALawsuitD3.jsx';

ReactGA.initialize('G-7C47MS8W8M');

const SiteLayout = () => (
  <div className="site-layout">
    <div className="site-layout__content">
      <Outlet />
    </div>
    <Footer />
  </div>
);

const App = () => {
  const router = createBrowserRouter([
    {
      element: <SiteLayout />,
      children: [
    {
      path: "/",
      element:<HomeMain/>,
    },
    {
      path: "/PrivacyPolicy",
      element: <LegalPage {...LEGAL_PAGES.privacy} />,
    },
    {
      path: "/Disclaimer",
      element: <LegalPage {...LEGAL_PAGES.disclaimer} />,
    },
    {
      path: "/disclaimer",
      element: <LegalPage {...LEGAL_PAGES.disclaimer} />,
    },
    {
      path: "/privacy-policy",
      element: <LegalPage {...LEGAL_PAGES.privacy} />,
    },
    {
      path: "/terms-and-conditions",
      element: <LegalPage {...LEGAL_PAGES.terms} />,
    },
    {
      path: "/state-privacy-rights",
      element: <LegalPage {...LEGAL_PAGES.stateRights} />,
    },
    {
      path: "/consumer-health-data-privacy",
      element: <LegalPage {...LEGAL_PAGES.healthData} />,
    },
    {
      path: "/privacy-choices",
      element: <LegalPage {...LEGAL_PAGES.choices} />,
    },
    {
      path: "/cookie-policy",
      element: <LegalPage {...LEGAL_PAGES.cookie} />,
    },
    {
      path: "/notice-at-collection",
      element: <LegalPage {...LEGAL_PAGES.notice} />,
    },
    {
      path: "/Depo-Provera-lawsuit",
      element: <Depomain />,
    },
    {
      path: "/Toxic-Baby-Food",
      element: <BabyfoodMain />,
    },
    {
      path: "/Paraquat-lawsuit",
      element: <ParaquatMain />,
    },
    {
      path: "/Roundup-Lawsuit",
      element: <RoundUpMain />,
    },
    {
      path: "/Active-lawsuits",
      element: <ServiceMain />,
    },
    {
      path: "/AboutUs",
      element: <AboutUs />,
    },
    {
      path: "/ContactUs",
      element: <ContactUs />,
    },
    {
      path: "/AFFF-Lawsuit",
      element: <AFFFMain />,
    },
    {
      path: "/Bard-PowerPort",
      element: <BardPowerPortMain />,
    },
    {
      path: "/Talcum-Lawsuit",
      element: <TalcumMain />,
    },
    {
      path: "/Transvaginal-Mesh-Lawsuit",
      element: <TransvaginalMain />,
    },
    {
      path: "/UltraProcessedMain",
      element: <UltraProcessedMain />,
    },
    {
      path: "/Oxbryta-Lawsuit",
      element: <OxbrytaMain />,
    },
    {
      path: "/PFAS-Lawsuits",
      element: <PFASMain />,
    },{
      path:"/Ozempic-Lawsuit",
      element: <OzempicLawsuitMain/>,
    },
    {
      path:"/Hair-Relaxer-Lawsuit",
      element: <HairRelaxerLawsuitMain/>,
    },
    {
      path: '/depo-provera-lawsuit-a',
      element: <DepoProveraLawsuit />
    },
    {
      path: '/talcum-powder-lawsuit-a',
      element: <TalcumPowderLawsuit />
    },
    {
      path: '/hernia-mesh-lawsuit-a',
      element: <HerniaMeshLawsuit />
    },
    {
      path: '/ozempic-lawsuit-a',
      element: <OzempicLawsuit />
    },
    {
      path: '/hair-relaxer-lawsuit-a',
      element: <HairRelaxerLawsuit />
    },
    {
      path: '/rideshare-sa-lawsuit-a',
      element: <RideshareSexualAssaultLawsuit />
    },
    {
      path: '/social-media-addiction-lawsuit-a',
      element: <SocialMediaAddictionLawsuit />
    },
    {
      path: '/roblox-sa-lawsuit-a',
      element: <RobloxSALawsuit />
    },
    {
      path: '/roundup-lawsuit-a',
      element: <RoundupLawsuit />
    },
    {
      path: '/depo-provera-lawsuit-b',
      element: <DepoProveraLawsuitB />
    },
    {
      path: '/talcum-powder-lawsuit-b',
      element: <TalcumPowderLawsuitB />
    },
    {
      path: '/hernia-mesh-lawsuit-b',
      element: <HerniaMeshLawsuitB />
    },
    {
      path: '/ozempic-lawsuit-b',
      element: <OzempicLawsuitB />
    },
    {
      path: '/hair-relaxer-lawsuit-b',
      element: <HairRelaxerLawsuitB />
    },
    {
      path: '/rideshare-sa-lawsuit-b',
      element: <RideshareSexualAssaultLawsuitB />
    },
    {
      path: '/social-media-addiction-lawsuit-b',
      element: <SocialMediaAddictionLawsuitB />
    },
    {
      path: '/roblox-sa-lawsuit-b',
      element: <RobloxSALawsuitB />
    },
    {
      path: '/depo-provera-lawsuit-c',
      element: <DepoProveraLawsuitC />
    },
    {
      path: '/talcum-powder-lawsuit-c',
      element: <TalcumPowderLawsuitC />
    },
    {
      path: '/hernia-mesh-lawsuit-c',
      element: <HerniaMeshLawsuitC />
    },
    {
      path: '/ozempic-lawsuit-c',
      element: <OzempicLawsuitC />
    },
    {
      path: '/hair-relaxer-lawsuit-c',
      element: <HairRelaxerLawsuitC />
    },
    {
      path: '/rideshare-sa-lawsuit-c',
      element: <RideshareSexualAssaultLawsuitC />
    },
    {
      path: '/social-media-addiction-lawsuit-c',
      element: <SocialMediaAddictionLawsuitC />
    },
    {
      path: '/roblox-sa-lawsuit-c',
      element: <RobloxSALawsuitC />
    },
    {
      path: '/depo-provera-lawsuit-d',
      element: <DepoProveraLawsuitD />
    },
    {
      path: '/talcum-powder-lawsuit-d',
      element: <TalcumPowderLawsuitD />
    },
    {
      path: '/hernia-mesh-lawsuit-d',
      element: <HerniaMeshLawsuitD />
    },
    {
      path: '/ozempic-lawsuit-d',
      element: <OzempicLawsuitD />
    },
    {
      path: '/hair-relaxer-lawsuit-d',
      element: <HairRelaxerLawsuitD />
    },
    {
      path: '/roblox-sa-lawsuit-d',
      element: <RobloxSALawsuitD />
    },
{
  path: '/dupixent-lawsuit-d',
  element: <DupixentLawsuitD />
},
{
  path: '/dupixent-lawsuit-a',
  element: <DupixentLawsuitA />
},
{
  path: '/dupixent-lawsuit-b',
  element: <DupixentLawsuitB />
},
{
  path: '/dupixent-lawsuit-c',
  element: <DupixentLawsuitC />
},
{
path:'/ozempic-lawsuit-e',
element: <NewMedicalOzempicLawsuitB />
},
{
  path:'/dupixent-lawsuit',
  element: <DupixentLawsuit />
},
{
  path:'/social-media-addiction-lawsuit',
  element: <SocialMediaAddictionLawsuits />
},
{
  path:'/medicare',
  element: <Medicare />
},
{
  path:'/hernia-mesh-lawsuit',
  element: <HerniaMeshLawsuits />
},
{
path:'/ssdi-a',
element: <SSDILawsuit />
},
{
path:'/aca-health-insurance-lawsuit-a',
element: <ACAHealthInsuranceLawsuit />
},
{
path:'/auto-insurance-lawsuit-a',
element: <AutoInsuranceLawsuit />
},
{
path:'/final-expense-insurance-lawsuit-a',
element: <FinalExpenseInsuranceLawsuit />
},
{
path:'/ssdi',
element: <SSDILawsuitServices />
},
{
  path: '/depo-provera-lawsuit-a-kq',
  element: <KqDepoProveraLawsuit />
},
{
  path: '/talcum-powder-lawsuit-a-kq',
  element: <KqTalcumPowderLawsuit />
},
{
  path: '/hernia-mesh-lawsuit-a-kq',
  element: <KqHerniaMeshLawsuit />
},
{
  path: '/ozempic-lawsuit-a-kq',
  element: <KqOzempicLawsuit />
},
{
  path: '/hair-relaxer-lawsuit-a-kq',
  element: <KqHairRelaxerLawsuit />
},
{
  path: '/rideshare-sa-lawsuit-a-kq',
  element: <KqRideshareSexualAssaultLawsuit />
},
{
  path: '/social-media-addiction-lawsuit-a-kq',
  element: <KqSocialMediaAddictionLawsuit />
},
{
  path: '/roblox-sa-lawsuit-a-kq',
  element: <KqRobloxSALawsuit />
},
{
  path: '/roundup-lawsuit-a-kq',
  element: <KqRoundupLawsuit />
},
{
  path: '/depo-provera-lawsuit-b-kq',
  element: <KqDepoProveraLawsuitB />
},
{
  path: '/talcum-powder-lawsuit-b-kq',
  element: <KqTalcumPowderLawsuitB />
},
{
  path: '/hernia-mesh-lawsuit-b-kq',
  element: <KqHerniaMeshLawsuitB />
},
{
  path: '/ozempic-lawsuit-b-kq',
  element: <KqOzempicLawsuitB />
},
{
  path: '/hair-relaxer-lawsuit-b-kq',
  element: <KqHairRelaxerLawsuitB />
},
{
  path: '/rideshare-sa-lawsuit-b-kq',
  element: <KqRideshareSexualAssaultLawsuitB />
},
{
  path: '/social-media-addiction-lawsuit-b-kq',
  element: <KqSocialMediaAddictionLawsuitB />
},
{
  path: '/roblox-sa-lawsuit-b-kq',
  element: <KqRobloxSALawsuitB />
},
{
  path: '/depo-provera-lawsuit-c-kq',
  element: <KqDepoProveraLawsuitC />
},
{
  path: '/talcum-powder-lawsuit-c-kq',
  element: <KqTalcumPowderLawsuitC />
},
{
  path: '/hernia-mesh-lawsuit-c-kq',
  element: <KqHerniaMeshLawsuitC />
},
{
  path: '/ozempic-lawsuit-c-kq',
  element: <KqOzempicLawsuitC />
},
{
  path: '/hair-relaxer-lawsuit-c-kq',
  element: <KqHairRelaxerLawsuitC />
},
{
  path: '/rideshare-sa-lawsuit-c-kq',
  element: <KqRideshareSexualAssaultLawsuitC />
},
{
  path: '/social-media-addiction-lawsuit-c-kq',
  element: <KqSocialMediaAddictionLawsuitC />
},
{
  path: '/roblox-sa-lawsuit-c-kq',
  element: <KqRobloxSALawsuitC />
},
{
  path: '/depo-provera-lawsuit-d-kq',
  element: <KqDepoProveraLawsuitD />
},
{
  path: '/talcum-powder-lawsuit-d-kq',
  element: <KqTalcumPowderLawsuitD />
},
{
  path: '/hernia-mesh-lawsuit-d-kq',
  element: <KqHerniaMeshLawsuitD />
},
{
  path: '/ozempic-lawsuit-d-kq',
  element: <KqOzempicLawsuitD />
},
{
  path: '/hair-relaxer-lawsuit-d-kq',
  element: <KqHairRelaxerLawsuitD />
},
{
  path: '/roblox-sa-lawsuit-d-kq',
  element: <KqRobloxSALawsuitD />
},
{
  path: '/dupixent-lawsuit-d-kq',
  element: <KqDupixentLawsuitD />
},
{
  path: '/dupixent-lawsuit-a-kq',
  element: <KqDupixentLawsuitA />
},
{
  path: '/dupixent-lawsuit-b-kq',
  element: <KqDupixentLawsuitB />
},
{
  path: '/dupixent-lawsuit-c-kq',
  element: <KqDupixentLawsuitC />
},
{
  path:'/ssdi-a-kq',
  element: <KqSSDILawsuit />
},
{
  path: '/:slug',
  element: <DynamicTemplatePage />
},
{
  path: '/ssdi-e-kq',
  element: <QualificationForm />
},
{
  path: '/ssdi-rig',
  element: <SSDIRIG />
},
{
  path: '/ssdi-e',
  element: <QualificationForm2 />
},
{
  path:'/test',
  element:<Test/>
},
{
path: '/roblox-sa-lawsuit-a-1',
element: <RobloxSALawsuit1 />
},
{path: '/roblox-sa-lawsuit-a-2',
element: <RobloxSALawsuit2 /> 
},
{
element: <RobloxSALawsuit3 />,
path: '/roblox-sa-lawsuit-a-3'
},
{

  element: <RobloxSALawsuitB1 />,  
  path: '/roblox-sa-lawsuit-b-1'
},
{
  element: <RobloxSALawsuitB2 />, 
  path: '/roblox-sa-lawsuit-b-2'
},
{
  element: <RobloxSALawsuitB3 />,
  path: '/roblox-sa-lawsuit-b-3'
},
{
  element: <RobloxSALawsuitC1 />,     
  path: '/roblox-sa-lawsuit-c-1'
},
{
  element: <RobloxSALawsuitC2 />,
  path: '/roblox-sa-lawsuit-c-2'
},
{
  element: <RobloxSALawsuitC3 />, 
  path: '/roblox-sa-lawsuit-c-3'
},
{
  element: <RobloxSALawsuitD1 />,
  path: '/roblox-sa-lawsuit-d-1'
},
{
  element: <RobloxSALawsuitD2 />,
  path: '/roblox-sa-lawsuit-d-2'
},
{
  element: <RobloxSALawsuitD3 />,
  path: '/roblox-sa-lawsuit-d-3'
},
{
  path: "*",
  element: <NotFound />
}

      ]
    }
  ])
  return (
    <div>
      <RouterProvider router={router} />
    </div>
  )
}

export default App
